import { makeStyles } from 'tss-react/mui';
import { colors, theme } from '../../theme';

/**
 * Custom hook that defines the styles for the settings modal component.
 */
const useSettingsModalStyles = makeStyles()(() => ({
  settings: {
    color: colors.gray['400'],
    width: '35px',
    height: '35px',
    cursor: 'pointer',
  },
  settingsContent: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: theme.gap.l,
  },
  userInfoSettings: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: theme.gap.l,
    width: '100%',
    flexWrap: 'wrap',
  },
  entrySettings: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: theme.gap.m,
  },
  editIcon: {
    'color': theme.primary.light,
    'cursor': 'pointer',
    '&:hover': {
      color: theme.primary.dark,
    },
    '&:active': {
      color: theme.primary.darker,
    },
  },
  avatar: {
    width: theme.iconSize,
    height: theme.iconSize,
    border: `1.5px solid ${colors.black}`,
  },
  buttonOptions: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    width: '100%',
    flexWrap: 'wrap',
    margin: theme.margin.m,
    gap: theme.gap.m,
  },
  deleteAccountButton: {
    'backgroundColor': colors.red[500],
    'border': `1px solid ${colors.red[500]}`,
    'marginLeft': 0,
    'marginRight': 0,
    '&:hover': {
      backgroundColor: colors.red[600],
      borderColor: colors.red[600],
    },
    '&:active': {
      backgroundColor: colors.red[600],
      boxShadow: theme.buttonShadow(colors.red[600]),
      borderColor: colors.red[600],
    },
  },
  applyChangesButton: {
    'backgroundColor': colors.green[400],
    'border': `1px solid ${colors.green[400]}`,
    'marginLeft': 0,
    'marginRight': 0,
    '&:hover': {
      backgroundColor: colors.green[500],
      borderColor: colors.green[500],
    },
    '&:active': {
      backgroundColor: colors.green[600],
      boxShadow: theme.buttonShadow(colors.green[600]),
      borderColor: colors.green[600],
    },
  },
  input: {
    margin: 0,
  },
  entryErrorSettings: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: theme.gap.s,
  },
  error: {
    fontFamily: theme.fontFamily,
    color: colors.red['400'],
    marginBottom: theme.margin.m,
    fontSize: theme.fontSize.smaller,
    marginTop: theme.margin.xs,
    fontWeight: theme.fontWeight.medium,
  },
}));

export default useSettingsModalStyles;
